import { cn } from '@rental/ui'
import type { ReactNode } from 'react'

/**
 * A part of a pane with a heading of its own (DESIGN.md, "A screen and its
 * parts"): a form or a tool inside a section, such as recording a payment.
 * A well sunk into the pane, not a box drawn on it: the pane's rules stay
 * for separating content.
 */
export function SubPanel({
  title,
  children,
  className,
}: {
  title: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex flex-col gap-3 rounded-sm bg-surface-well p-4', className)}>
      <h3 className="text-lg">{title}</h3>
      {children}
    </div>
  )
}

/**
 * Why a button cannot be pressed yet, each missing thing in words, beside
 * the button (DESIGN.md: never a disabled button with no reason). The button
 * names this list with `aria-describedby`, so a screen reader hears it too.
 */
export function ReasonList({ id, reasons }: { id: string; reasons: readonly string[] }) {
  if (reasons.length === 0) return null
  return (
    <ul id={id} className="flex list-disc flex-col gap-1 ps-6 text-sm text-text-muted">
      {reasons.map((reason) => (
        <li key={reason}>{reason}</li>
      ))}
    </ul>
  )
}
